import * as React from 'react';
import * as PropTypes from 'prop-types';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as request from 'superagent';
import { RouteComponentProps } from 'react-router';

import * as GroupActions from '../../actions/group';
import * as StoryActions from '../../actions/story';
import * as UserActions from '../../actions/users';
import { RootState } from '../../reducers';

import { GroupData } from '../../models/Group';
import { UserData } from '../../models/User';
import { StoryInfo, SelectedStory } from '../../models/Story';
import { CampaignData } from '../../models/Campaign';
import { StudentData } from '../../models/Student';

import { Status } from '../Campaign/status';
import { Diary } from '../Campaign/diary';
import { StudentContainer } from '../GroupSettings/studentcontainer';
import { Header } from '../Common/header';
import { ReturnButton } from '../Common/returnbutton';

const emptyCampaign = {
	group: '',
	_id: '',
	evaluations: [],
	name: '',
	active: false
}

export namespace Evaluation {
	export interface Props extends RouteComponentProps<void> {
		groupActions: typeof GroupActions;
		storyActions: typeof StoryActions;
		userActions: typeof UserActions;
		group: GroupData;
		user: UserData;
		stories: StoryInfo[];
		selectedStory: SelectedStory;
	}

	export interface State {
		campaign: CampaignData;
		selectedStudent: StudentData;
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Evaluation extends React.Component<Evaluation.Props, Evaluation.State> {

	static contextTypes = {
		router: PropTypes.func.isRequired
	}

	constructor(props: Evaluation.Props) {
		super(props);


		console.log(props);

		const { group, selectedStory, storyActions } = props;

		this.viewStory = this.viewStory.bind(this);
		this.deleteStory = this.deleteStory.bind(this);
		this.selectStudent = this.selectStudent.bind(this);
		this.fetchStories = this.fetchStories.bind(this);
		this.selectCampaign = this.selectCampaign.bind(this);
		this.markImportantStory = this.markImportantStory.bind(this);
		this.markGradedStory = this.markGradedStory.bind(this);

		let campaign = emptyCampaign;
		if (group && group.campaigns && group.campaigns.length > 0) {
			campaign = group.campaigns[0];
		}

		let selStudent: StudentData = null;

		if (selectedStory.campaign_id === "" && campaign !== emptyCampaign) {
			storyActions.setSelectedStory({
				student_id: selectedStory.student_id,
				campaign_id: campaign._id
			});
		} else if (
			selectedStory.campaign_id !== ""
			&& group.campaigns.map(campaign => campaign._id).includes(selectedStory.campaign_id)
		) {
			campaign = group.campaigns.find(campaign => campaign._id === selectedStory.campaign_id);

			if (
				selectedStory.student_id !== ""
				&& group.students.map(student => student._id).includes(selectedStory.student_id)
			) {
				for (let i = 0; i < group.students.length; i++) {
					if (group.students[i]._id === selectedStory.student_id) {
						selStudent = group.students[i];
						break;
					}
				}
			}
		}

		this.state = {
			campaign: campaign,
			selectedStudent: selStudent,
		};
	}

	viewStory(id: string) {
		this.context.router.history.push("/play/" + this.state.campaign._id + "/" + id);
	}

	deleteStory(id: string) {
		const { storyActions, stories } = this.props;
		const story = stories.find((story) => story._id === id);
		storyActions.deleteStory(story);
	}

	markGradedStory(id: string) {
		const { storyActions, stories } = this.props;
		const story = stories.find((story) => story._id === id);
		story.graded = !story.graded;
		storyActions.markGradedStory(story);
	}

	markImportantStory(id: string) {
		const { storyActions, stories } = this.props;
		const story = stories.find((story) => story._id === id);
		story.important = !story.important;
		storyActions.markImportantStory(story);
	}

	fetchStories(studentId) {
		const { storyActions } = this.props;

		request
			.get('/story/stories')
			.set('Authorization', localStorage.getItem('token'))
			.query({ 'student': studentId })
			.end((err, res) => {
				storyActions.setStories(res.body.stories);
			});
	}

	selectStudent(id: string) {
		const { group, selectedStory, storyActions } = this.props;

		this.fetchStories(id);
		this.setState({ selectedStudent: group.students.find((o) => { return o._id === id }) });
		storyActions.setSelectedStory({
			student_id: id,
			campaign_id: selectedStory.campaign_id
		});
	}

	selectCampaign(e: any, findDirectById: string = "") {
		const { group, selectedStory, storyActions } = this.props;
		let newID = findDirectById;
		if (findDirectById === "") {
			const selectedCampaign = group.campaigns.find((campaign) => campaign.name === e.target.value);
			newID = selectedCampaign._id;
			this.setState({ campaign: selectedCampaign });
		} else {
			const selectedCampaign = group.campaigns.find((campaign) => campaign._id === findDirectById);
			this.setState({ campaign: selectedCampaign });
		}

		storyActions.setSelectedStory({
			student_id: selectedStory.student_id,
			campaign_id: newID
		});
	}

	render() {
		const { group, user, stories, selectedStory } = this.props;
		const { campaign, selectedStudent } = this.state;

		//if not yet loaded
		if (!group || !user) {
			return (<div></div>);
		}

		let content;

		let actions = {
			addStudent: (values: any) => { return; },
			selectStudent: this.selectStudent
		};

		let campaignOptions = [];

		for (let i = 0; i < group.campaigns.length; i++) {
			campaignOptions.push(<option
				selected={((campaign_id): boolean => campaign_id === selectedStory.campaign_id)(group.campaigns[i]._id)}
				id={group.campaigns[i]._id}
			>
				{group.campaigns[i].name}
			</option>);
		}
		const campaignStories = stories.filter((story) => story.campaign === campaign._id);

		return (
			<div className="row m-3">
				<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.1.0/css/all.css" />
				<div className="row">
					<Header user={user} userActions={this.props.userActions} />
				</div>
				<div className="jumbotron am_studentcontainer col-12">
					<div className="row">
						<h3 className="am_title col-4">Kampanjat</h3>
						<select onChange={this.selectCampaign} className="form-control col-4">
							{campaignOptions}
						</select>
					</div>
					<div className="col-12 p-2 row">
						<div className="col-2">
							<div className="am_flexnoscroll am_whitecontainer">
								<StudentContainer students={group.students} actions={actions} student={selectedStudent} hideCreate={true} />
							</div>
						</div>
						<div className="col-7">
							<div className="am_innercontainer am_whitecontainer">
								<div className="am_flex am_whitecontainer">
									<div className="row">
										<div className="col-2 text-center">Ajankohta</div>
										<div className="col-2 text-center">Arvioidut asiat</div>
										<div className="col-3 text-center">Tarkistettu? - Tähdelliset</div>
									</div>
									<Diary stories={campaignStories} viewStory={this.viewStory} deleteStory={this.deleteStory}
										teacherControls={{ markImportant: this.markImportantStory, markGraded: this.markGradedStory }} />
								</div>
							</div>
						</div>
						<div className="col-3">
							<div className="am_flex am_whitecontainer">
								<Status evaluations={campaign.evaluations} stories={campaignStories} bigIcons={false} />
							</div>
						</div>
					</div>
				</div>
				<ReturnButton router={this.context.router} />
			</div>
		);
	}
}

function mapStateToProps(state: RootState, data: any) {
	console.log(state);
	var id = data.match.params.id;
	let group = state.groups.find((o) => { return o._id === id });

	return {
		group: group,
		user: state.user,
		stories: state.stories,
		selectedStory: state.selectedStory
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		groupActions: bindActionCreators(GroupActions as {}, dispatch),
		storyActions: bindActionCreators(StoryActions as {}, dispatch),
		userActions: bindActionCreators(UserActions as {}, dispatch)
	};
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Evaluation/index.tsx